import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgGooglePlayLogo: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.814 11.48L.234 21.65v.007a2.587 2.587 0 003.813 1.56l.03-.017 10.786-6.224-5.049-5.495z"
        fill="#F93647"
      />
      <path
        d="M19.508 9.75l-.01-.007-4.656-2.7-5.245 4.669 5.264 5.263 4.631-2.672a2.59 2.59 0 00.016-4.554z"
        fill="#FFC800"
      />
      <path
        d="M.232 2.349a2.537 2.537 0 00-.088.666v17.97c0 .23.03.454.088.666l9.912-9.91L.232 2.349z"
        fill="#00C5FF"
      />
      <path
        d="M9.885 12l4.96-4.958L4.072.796a2.594 2.594 0 00-3.84 1.55v.003L9.886 12z"
        fill="#00F076"
      />
    </Icon>
  )
}
export default SvgGooglePlayLogo
